<div class="settings-overlay" (click)="close.emit()"></div>
<aside class="settings-drawer" role="dialog" aria-label="Mandala settings">

  <header class="settings-head">
    <h2>Mandala</h2>
    <button type="button" class="settings-close" (click)="close.emit()" aria-label="Close">×</button>
  </header>

  <section class="settings-section">
    <h3>Ring order</h3>
    <p class="hint">Drag to reorder. Top of list = innermost ring.</p>
    <div cdkDropList (cdkDropListDropped)="drop($event)" class="order-list">
      <div *ngFor="let cat of ordered" cdkDrag class="order-row">
        <span class="drag-handle" aria-hidden="true">≡</span>
        <span class="cat-name">{{ cat }}</span>
      </div>
    </div>
  </section>

  <section class="settings-section">
    <h3>Per-category style</h3>
    <div *ngFor="let cat of ordered" class="style-row">
      <span class="cat-name">{{ cat }}</span>

      <label class="motif-select">
        <select [value]="styleFor(cat).motif" (change)="onMotifPick(cat, $any($event.target).value)">
          <option *ngFor="let m of motifChoices" [value]="m.id">{{ m.label }}</option>
        </select>
        <svg class="motif-preview" viewBox="-12 -12 24 24" [innerHTML]="motifSvgPreview(styleFor(cat).motif, styleFor(cat).color)"></svg>
      </label>

      <input
        type="color"
        class="color-swatch"
        [value]="styleFor(cat).color"
        (change)="onColorPick(cat, $any($event.target).value)"
        [attr.aria-label]="'Color for ' + cat">
    </div>
  </section>

  <section class="settings-section" *ngIf="hasOverflow">
    <h3>Visible rings <span class="cap-hint">(max {{ maxVisible }})</span></h3>
    <p class="hint">You have more than {{ maxVisible }} categories — pick which ones to show in the mandala.</p>
    <label *ngFor="let cat of allActiveCategories" class="vis-row">
      <input
        type="checkbox"
        [checked]="isVisible(cat)"
        [disabled]="!canCheckMore(cat)"
        (change)="toggleVisible(cat)">
      <span>{{ cat }}</span>
    </label>
  </section>

  <footer class="settings-foot">
    <button type="button" class="settings-reset" (click)="resetToDefaults.emit()">Reset to defaults</button>
    <button type="button" class="settings-done" (click)="close.emit()">Done</button>
  </footer>

</aside>
